// 数字人视频source
export const digitalVideoSource = 36;
// 片段生成视频source
export const imageTypeVideoSource = 42;
export const textTypeVideoSource = 48;
export const img2videoSource = [imageTypeVideoSource, textTypeVideoSource]; // 42代表图生视频，48代表文生视频，两者都是
// 模板视频source
export const videoTplSource = 18;
// 短剧高光视频source
export const highlightSource = 49;

// 目前的所有视频source（查全部时用到，后续增加需拓展）
export const allDigitalSource = [
    digitalVideoSource,
    ...img2videoSource,
    videoTplSource,
    highlightSource
];